const EditCircleIcon = () => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 35 35"
    width="35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17.5" cy="17.5" fill="#F77115" r="17.5" />
    <path
      d="M12 23.5934H14.4842L23.5934 14.4842L21.1089 12L12 21.1092V23.5934Z"
      stroke="#F3F3F0"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M18.625 14.4844L21.1092 16.9686"
      stroke="#F3F3F0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export default EditCircleIcon
